import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./vp7200.css";

function VP6825() {
    const [mainImage, setMainImage] = useState("/images/6825/3-1.png");
    const [activeTab, setActiveTab] = useState("features");

    const thumbnails = [
        "/images/6825/3-1.png",
        "/images/6825/3-2.png",
        "/images/6825/3-3.png",
        "/images/6825/3-4.png",
        "/images/6825/3-5.png",
    ];
    return (
        <>
            <Header />
            <section className="vp7200-container">

                {/* LEFT SIDE */}
                <div className="vp7200-left">
                    <div className="main-image">
                        <img src={mainImage} alt="AP6800" />
                    </div>

                    {/* <div className="thumbnails">
            {thumbnails.map((img, index) => (
              <img
                key={index}
                src={img}
                alt=""
                onClick={() => setMainImage(img)}
              />
            ))}
          </div> */}
                    <div className="thumbnails">

                        {/* TOP ROW (2 IMAGES) */}
                        <div className="thumb-row top-row">
                            {thumbnails.slice(0, 3).map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt=""
                                    onClick={() => setMainImage(img)}
                                />
                            ))}
                        </div>

                        {/* BOTTOM ROW (3 IMAGES) */}
                        <div className="thumb-row bottom-row">
                            {thumbnails.slice(3, 5).map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt=""
                                    onClick={() => setMainImage(img)}
                                />
                            ))}
                        </div>

                    </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="vp7200-right">

                    {/* TOP CONTENT */}
                    <div className="content-top">
                        <h1>VP6825</h1>
                        <h3>All Weather Unattended Payment Device</h3>

                        <p>
                            A robust, Android-powered unattended payment terminal with touchscreen interface, designed for high-traffic self-service environments.
                        </p>

                        <p>
                            It combines secure card-present payments with application hosting and interactive user experiences, making it ideal for <b>EV Charging, Vending, Parking, and Kiosk deployments</b>.
                        </p>
                    </div>

                    {/* TABS */}
                    <div className="tabs">
                        <button
                            className={activeTab === "features" ? "active" : ""}
                            onClick={() => setActiveTab("features")}
                        >
                            KEY FEATURES
                        </button>

                        <button
                            className={activeTab === "specs" ? "active" : ""}
                            onClick={() => setActiveTab("specs")}
                        >
                            SPECIFICATIONS
                        </button>
                    </div>

                    {/* TAB CONTENT */}
                    <div className="tab-content">
                        {activeTab === "features" && (
                            <ul>
                                <li>PCI PTS 6.X certified with PIN-on-glass</li>
                                <li>Supports chip, PIN, contactless, QR/barcodes magstripe payment methods</li>
                                <li>Supports Apple/Google/Samsung Pay & loyalty & rewards programs</li>
                                <li>Supports up to 4 SAM, 2 SIM & 1 SD Slot</li>
                                <li>Optional MDB Interface Support</li>
                                <li>Can host & run customer payment applications</li>
                                <li>Ruggedized design, water-resistant with wide operating temperature range</li>
                                <li>4.3" digital touchscreen display</li>
                            </ul>
                        )}

                        {activeTab === "specs" && (
                            <ul>
                                <li>Connectivity: USB-C, Ethernet, LTE</li>
                                <li>Operating Temp: -30°C to 70°C</li>
                                <li>Security: PCI PTS 6.x</li>
                                <li>Ingress Protection: IP65</li>
                                <li>Dimensions: Compact form factor</li>
                            </ul>
                        )}
                    </div>
                </div>
            </section>
            <section className="vp7200-benefits">

                <div className="vp7200-benefits-container">

                    {/* LEFT CONTENT */}
                    <div className="benefits-left">
                        <h2>Powering Payments, Wherever They Happen</h2>

                        <p>
                            The VP6825 is designed for businesses that need a secure, reliable, and versatile unattended
                            payment solution. Its rugged design, flexible connectivity, and multi-payment support make it
                            perfect for self-service environments, from EV charges to vending machines, ensuring a smooth
                            customer experience while keeping transactions safe.
                        </p>

                        <ul>
                            <li>Multi-Payment Ready: Accepts Chip, PIN, contactless/NFC, and mobile wallets like Apple Pay and Google Pay</li>
                            <li>Rugged & Reliable: IP65 water resistance and IK08 impact protection for harsh environments</li>
                            <li>Interactive Touchscree: 4.3" display for PIN-on-glass and customer guidance.</li>
                            <li>Flexible Integration: Supports Ethernet, Wi-Fi, Bluetooth, USB-C, and optional LTE Connectivity.</li>
                        </ul>

                        {/* PAYMENT METHODS */}
                        <h3 className="payment-title">Multiple Payment Methods</h3>

                        <div className="payment-logos">
                            <img src="/images/7200/gpay.png" alt="GPay" />
                            <img src="/images/7200/mc.png" alt="Mastercard" />
                            <img src="/images/7200/amex.png" alt="Amex" />
                            <img src="/images/7200/visa.png" alt="Visa" />
                            <img src="/images/7200/apple.png" alt="Apple Pay" />
                            <img src="/images/7200/samsung.png" alt="Samsung Pay" />
                            <img src="/images/7200/alipay.png" alt="Alipay" />
                        </div>
                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="benefits-right">
                        <img
                            src="/images/6800/2-7.png"
                            alt="Kiosk"
                        />
                    </div>
                </div>
            </section>
            <section className="vp7200-features">
                <div className="vp7200-features-container">
                    <div className="feature-item">
                        <img src="/images/7200/flex-connect.png" alt="Connectivity" />
                        <h4>Flexible Connectivity</h4>
                        <p>Integrate seamlessly into your existing infrastructure.</p>
                    </div>

                    <div className="feature-item">
                        <img src="/images/7200/secure.png" alt="Security" />
                        <h4>Secure & Compliant</h4>
                        <p>Protect your business and customers with advanced security.</p>
                    </div>

                    <div className="feature-item">
                        <img src="/images/7200/rugged.png" alt="Rugged" />
                        <h4>Rugged & Reliable</h4>
                        <p>Built to withstand tough environments and 24/7 use.</p>
                    </div>

                    <div className="feature-item">
                        <img src="/images/7200/cust.png" alt="Customer" />
                        <h4>Customer Engagement</h4>
                        <p>Enhance the payment experience and drive loyalty.</p>
                    </div>
                </div>
            </section>
            <section className="vp7200-specs">

                <div className="vp7200-specs-container">

                    <h2 className="specs-title">Technical Specifications</h2>

                    {/* ELECTRICAL */}
                    <div className="spec-group">
                        <div className="spec-label">ELECTRICAL</div>

                        <div className="spec-content electrical">
                            <div className="spec-row">
                                <span>CERTIFICATION</span>
                                <p>PCI 6.X SRED<br/>EMV L1 & L2<br/>EMV CONTACTLESS L2S: AMEX, DISCOVER, INTERAC, JCB, MASTERCARD, VISA<br/>APPLE VAS, FELICA, GOOGLE SMART TAP & MORE<br/></p>
                            </div>

                            <div className="spec-row">
                                <span>POWER</span>
                                <p>9V/3A</p>
                            </div>
                        </div>
                    </div>

                    {/* ENVIRONMENTAL */}
                    <div className="spec-group">
                        <div className="spec-label">ENVIRONMENTAL</div>

                        <div className="spec-content environmental">
                            <div className="spec-row">
                                <span>IMPACT RATING</span>
                                <p>IK08</p>
                            </div>

                            <div className="spec-row">
                                <span>INGRESS PROTECTION RATING</span>
                                <p>IP65</p>
                            </div>

                            <div className="spec-row">
                                <span>OPERATING TEMPERATURE</span>
                                <p>-20°C TO 65°C</p>
                            </div>

                            <div className="spec-row">
                                <span>STORAGE TEMPERATURE</span>
                                <p>-30°C TO 80°C</p>
                            </div>
                        </div>
                    </div>

                    {/* MECHANICAL */}
                    <div className="spec-group">
                        <div className="spec-label">MECHANICAL</div>

                        <div className="spec-content mechanical">
                            <div className="spec-row">
                                <span>DIMENSIONS</span>
                                <p>132MM X 87.7MM (TOTAL THICKNESS 45.8MM; WHEN MOUNTING TO KIOSK, THICKNESS OF EXPOSED PORTION IS 28.3M) +/- .20MM</p>
                            </div>

                            <div className="spec-row">
                                <span>DISPLAY</span>
                                <p>4.3" TFT 480 X 272 PIXELS (CAPACITIVE TOUCH), UP TO 800 NITS</p>
                            </div>

                            <div className="spec-row">
                                <span>MEMORY</span>
                                <p>FLASH 128MB, DRAM 64MB</p>
                            </div>

                            <div className="spec-row">
                                <span>INTERFACE</span>
                                <p>BLUETOOTH/WIFI, ETHERNET, RS232, USB-C, LTE 4G CAT1</p>
                            </div>

                            <div className="spec-row">
                                <span>PAYMENT INTERFACES</span>
                                <p>SMARTCARD READER: ISO7816<br/>CONTACTLESS CARD READER<br/>3-TRACK MAGNETIC CARD READER<br/>GREEN LED INDICATORS FOR SMARTCARD & MSR INTERFACES</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default VP6825;